import React, { useState } from "react";
import Modal from "../controls/popup/Modal";
import InputTextBox from "../controls/input/InputTextBox";
import * as Call from "../../utils/validations";

const initialData = {
  eventCode: "",
  errors: {},
  IsValid: {},
};

const EventCodePopup = ({ onClose, eventDetails }) => {
  const [showModal, setShowModal] = useState(true);
  const [inputValue, setInputValue] = useState(initialData);

  const handleClose = () => {
    setShowModal(false); // Close the modal
    onClose(null); // Pass null to indicate no event code was entered
  };

  const handleEventCode = (event) => {
    if (
      inputValue?.IsValid &&
      inputValue?.IsValid?.eventCode &&
      inputValue.eventCode === eventDetails?.restrictionCode
    ) {
      setShowModal(false); // Close the modal after selection
      // Close the modal after selection
      onClose(inputValue.eventCode);
    } else {
      alert("Please enter valid event code.");
      return;
    }
  };

  const handleChange = (e) => {
    //get Value
    const { name, value } = e.target;
    debugger;
    //check validation
    let result = isValid(name, value, e);
    //setInputValue
    if (result.name2 !== "") {
      setInputValue((prev) => ({
        ...prev,
        [result.name]: result.value === "" ? "" : result.value,
        [result.name2]: result.value2 === "" ? "" : result.value2,
        ["errors"]: { ...prev.errors, [name]: result.message },
        ["IsValid"]: { ...prev.IsValid, [name]: result.status },
      }));
    } else {
      setInputValue((prev) => ({
        ...prev,
        [result.name]: result.value === "" ? "" : result.value,
        ["errors"]: { ...prev.errors, [name]: result.message },
        ["IsValid"]: { ...prev.IsValid, [name]: result.status },
      }));
    }
  };
  const isValid = (name, value, e) => {
    let val = false;
    let msg = "";
    let name2 = "";
    let value2 = "";
    if (Call.IsEmpty(value)) {
      msg = "Please enter " + name;
    } else {
      switch (name) {
        case "eventCode":
          val = value.length > 4;
          if (!val) msg = "Please enter minimum 4 charactor.";
          break;

        default:
          break;
      }
    }

    return {
      status: val,
      message: msg,
      name: name,
      value: value,
      name2: name2,
      value2: value2,
    };
  };

  return (
    <>
      {showModal && (
        <Modal
          title="Please enter the event code."
          onClose={handleClose}
          class="custom-modal-select-event-type"
          onSuccess={handleEventCode}
          successText="Apply"
        >
          <>
            <form class="row g-3 needs-validation" novalidate>
              <div class="col-md-6">
                <label for="validationCustom01" class="form-label">
                  Event Code
                </label>
                <InputTextBox
                  id="eventCode"
                  name="eventCode"
                  placeholder="Please enter event code."
                  maxLength={10}
                  minLength={4}
                  onChange={handleChange}
                  isValid={inputValue?.IsValid?.eventCode}
                  errorMsg={inputValue?.errors?.eventCode}
                  value={inputValue.eventCode}
                />
              </div>
            </form>
          </>
        </Modal>
      )}
    </>
  );
};

export default EventCodePopup;
